import React, { useEffect } from 'react'

import { useFetchTemplate } from 'queries/templates'

import TemplatePreviewModal from 'pages/Authenticated/Templates/components/TemplatePreviewModal/TemplatePreviewModal.component'
import { useIsTemplatePurchaseRequired } from 'hooks/useIsTemplatePurchaseRequired'
import { useTemplateActions } from 'hooks/useTemplateActions'
import { useHistory } from 'react-router-dom'

interface Props {
  templateId: string
}

const TemplatePreview: React.FC<Props> = ({ templateId }) => {
  const { onUseTemplate } = useTemplateActions()
  const requirePayment = useIsTemplatePurchaseRequired(templateId)
  const { push, location } = useHistory()

  const { data, isLoading, refetch } = useFetchTemplate(templateId)
  useEffect(() => {
    refetch()
  }, [refetch, templateId])

  const onClose = () => {
    push(location.pathname)
  }

  return (
    <TemplatePreviewModal
      requirePayment={requirePayment}
      isOpen={!!templateId}
      template={data!}
      questionsLength={data?.questions.length}
      // actionBtnDisabled={!data?.questions.length}
      // actionBtnDisabled={false}
      isLoading={!data || isLoading}
      onClose={onClose}
      onUseTemplate={onUseTemplate}
      editingDisabled={true}
      noQuestions={!!data && !data.questions.length}
      // noQuestions={false}
    />
  )
}

export default TemplatePreview
